var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminPicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#6B7280",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3161 9.45446C20.4741 8.51651 19.298 8 18 8C16.695 8 15.5151 8.51339 14.677 9.44553C13.8298 10.3879 13.417 11.6687 13.514 13.0518C13.7061 15.7803 15.7185 17.9999 18 17.9999C20.2815 17.9999 22.2905 15.7808 22.4856 13.0526C22.5838 11.6821 22.1684 10.404 21.3161 9.45446ZM25.6152 27.9999H10.3848C10.1855 28.0026 9.98805 27.9594 9.80692 27.8734C9.62579 27.7874 9.46551 27.6609 9.33774 27.503C9.0565 27.1561 8.94313 26.6825 9.02707 26.2035C9.39226 24.1133 10.5319 22.3575 12.3232 21.1249C13.9146 20.0307 15.9305 19.4285 18 19.4285C20.0695 19.4285 22.0854 20.0312 23.6768 21.1249C25.4681 22.3571 26.6077 24.1129 26.9729 26.203C27.0569 26.682 26.9435 27.1557 26.6623 27.5026C26.5345 27.6606 26.3743 27.7872 26.1931 27.8732C26.012 27.9592 25.8146 28.0025 25.6152 27.9999Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPicIcon);
export default __webpack_public_path__ + "static/media/AdminPicIcon.54fc7a2e8579ba7a19970bbc5222abb4.svg";
export { ForwardRef as ReactComponent };